/* IndustryPapa v2 — main.js */

/* ── MOBILE MENU ── */
function openMobileMenu()  { document.getElementById('mobileMenu').classList.add('open'); document.body.style.overflow='hidden'; }
function closeMobileMenu() { document.getElementById('mobileMenu').classList.remove('open'); document.body.style.overflow=''; }

/* ── FAQ ACCORDION ── */
document.addEventListener('click', function(e) {
  var faqQ = e.target.closest('.faq-q');
  if (!faqQ) return;
  var item = faqQ.closest('.faq-item');
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(el) { el.classList.remove('open'); });
  if (!isOpen) item.classList.add('open');
});

/* ── PHOTO SEARCH ── */
function handlePhotoSearch(input) {
  if (!input.files || !input.files[0]) return;
  var file = input.files[0];
  var section = document.getElementById('photoResultSection');
  if (section) {
    section.style.display = 'block';
    section.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var wrap = document.getElementById('uploadedPhotoWrap');
    if (wrap) {
      var img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
      wrap.innerHTML = '';
      wrap.appendChild(img);
    }
    var result = document.getElementById('aiResult');
    if (result) {
      result.innerHTML = '<div style="font-size:12px;color:#888;">🔍 Analysing your photo…</div>';
      setTimeout(function() {
        result.innerHTML = '<div style="font-size:12px;font-weight:600;color:#1a5276;margin-bottom:4px;">✅ Sensor Identified!</div>'
          + '<div style="font-size:11px;color:#555;">Photoelectric Sensor detected. Matching products shown below. An authorised dealer will be notified.</div>';
      }, 1800);
    }
  }
}

/* ── SHOPIFY AJAX ADD TO CART ── */
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form.action || !form.action.includes('/cart/add')) return;
  e.preventDefault();
  fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
    .then(function(r) { return r.json(); })
    .then(function() { return fetch('/cart.js'); })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = 'Cart (' + cart.item_count + ')';
      });
      showToast('✅ Added to cart!', '#27ae60');
    })
    .catch(function() { form.submit(); });
});

function showToast(msg, bg) {
  var t = document.getElementById('ipToast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'ipToast';
    t.style.cssText = 'position:fixed;bottom:70px;right:16px;z-index:9999;padding:10px 18px;border-radius:6px;font-size:13px;font-weight:600;color:white;box-shadow:0 3px 12px rgba(0,0,0,0.2);opacity:0;transition:opacity 0.3s;pointer-events:none;';
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.style.background = bg || '#1a5276';
  t.style.opacity = '1';
  clearTimeout(t._timer);
  t._timer = setTimeout(function() { t.style.opacity = '0'; }, 2600);
}
